module.exports = __webpack_public_path__ + "static/media/no-candidate-960.d9b31bc2.webp";